/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type SelfProfileUpdatesMutationVariables = Types.Exact<{
  input: Types.SelfProfileUpdateInput;
}>;


export type SelfProfileUpdatesMutation = { __typename: 'Mutation', selfProfileUpdate: { __typename: 'SelfProfileUpdatePayload', user: { __typename: 'User', locale?: string | null, tempUnit?: string | null } } };


export const SelfProfileUpdatesDocument = gql`
    mutation SelfProfileUpdates($input: SelfProfileUpdateInput!) {
  selfProfileUpdate(input: $input) {
    user {
      locale
      tempUnit
    }
  }
}
    `;
export type SelfProfileUpdatesMutationFn = ApolloReactCommon.MutationFunction<SelfProfileUpdatesMutation, SelfProfileUpdatesMutationVariables>;

/**
 * __useSelfProfileUpdatesMutation__
 *
 * To run a mutation, you first call `useSelfProfileUpdatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfProfileUpdatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfProfileUpdatesMutation, { data, loading, error }] = useSelfProfileUpdatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelfProfileUpdatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SelfProfileUpdatesMutation, SelfProfileUpdatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SelfProfileUpdatesMutation, SelfProfileUpdatesMutationVariables>(SelfProfileUpdatesDocument, options);
      }
export type SelfProfileUpdatesMutationHookResult = ReturnType<typeof useSelfProfileUpdatesMutation>;
export type SelfProfileUpdatesMutationResult = ApolloReactCommon.MutationResult<SelfProfileUpdatesMutation>;
export type SelfProfileUpdatesMutationOptions = ApolloReactCommon.BaseMutationOptions<SelfProfileUpdatesMutation, SelfProfileUpdatesMutationVariables>;